import React from "react";
import Aboutfacility from "../components/Aboutus/Aboutfacility";
import Banner from '../comman/Banner/Banner';


const Aboutfacilitys = () => {
  return (
    <>
      <Banner
        index={'about-3'}
      />
      <Aboutfacility />
    </>

  )
};

export default Aboutfacilitys;